<div class="suppliers-registry-container">
  <!-- Breadcrumb -->
  <nav class="mb-4" aria-label="Breadcrumb">
    <p-breadcrumb 
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()" 
      [home]="{icon: 'pi pi-home', routerLink: '/axa/suppliers-dashboard'}">
    </p-breadcrumb>
  </nav>

  <!-- Page Header -->
  <section class="page-header" aria-labelledby="page-title">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-building header-icon" aria-hidden="true"></i>
        <div class="header-text">
          <h1 id="page-title">Registro Fornitori</h1>
          <p class="subtitle">Gestione e monitoraggio dei fornitori</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Reusable Table Component -->
  <app-registry-table
    [title]="tableTitle"
    [icon]="tableIcon"
    [columns]="columns"
    [data]="data()"
    [loading]="loading()"
    [showClearFiltersButton]="true"
    [showExportButton]="true"
    (onDetailClick)="onDetailClick($event)"
    (onEditClick)="onEditClick($event)"
    (onDeleteClick)="onDeleteClick($event)"
    (onClearFilters)="onClearFilters()"
    (onExport)="onExport()"
  />

  <!-- Toast for notifications -->
  <p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true" />
</div>

